var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.57391 2.09082L0.985997 9.74999C0.891405 9.9138 0.841354 10.0995 0.840825 10.2887C0.840295 10.4778 0.889305 10.6639 0.982978 10.8282C1.07665 10.9925 1.21172 11.1295 1.37476 11.2254C1.53779 11.3213 1.7231 11.3729 1.91225 11.375H11.0881C11.2772 11.3729 11.4625 11.3213 11.6256 11.2254C11.7886 11.1295 11.9237 10.9925 12.0174 10.8282C12.111 10.6639 12.16 10.4778 12.1595 10.2887C12.159 10.0995 12.1089 9.9138 12.0143 9.74999L7.42641 2.09082C7.32985 1.93163 7.19389 1.80001 7.03165 1.70867C6.8694 1.61732 6.68635 1.56934 6.50016 1.56934C6.31397 1.56934 6.13093 1.61732 5.96868 1.70867C5.80644 1.80001 5.67048 1.93163 5.57391 2.09082Z",
    stroke: "#F44336",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 4.875V7.04167",
    stroke: "#F44336",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.5 9.20825H6.50583",
    stroke: "#F44336",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.f88c5de621b1bf3c65bb797f5820af95.svg";
export { ForwardRef as ReactComponent };